/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetAllComplianceRegistrationLookups = require('../services/GetAllComplianceRegistrationLookups');
var SecIntCompRegNewView = require('../views/SecIntCompRegNewView');

module.exports = function() {
  NProgress.start();
  NProgress.set(0.6);
  $.when(GetAllComplianceRegistrationLookups())
    .done(function(complianceLookups) {
      NavUtils.navigate('#sec/compreg/new');
      Scaffold.content.show(
        new SecIntCompRegNewView({
          model: new Backbone.Model({
            professionalTypes: complianceLookups.professionalTypes
          })
        })
      );
      NProgress.done();
    })
    .fail(function(err) {
      NProgress.done();
    });
};
